// 落地页可配置
import { request } from '@/api/index';
import { ConfigurationProps } from '../components/landing/interface';

export interface AllIDReq {}

export interface AllIDRes {
  message: number;
}

export interface ConfigurableReq {
  id: string;
}

export interface ConfigurableRes {
  data: {
    message: string;
    content: boolean;
  };
}

interface GetLessonAvailableListReq {
  subject: string;
  timezone: string;
  operator?: string;
  language?: string;
  chineseLevel?: string;
  grade?: string;
  country?: string;
}

interface GetLessonAvailableDateListReq {
  chineseLevel?: string;
  country?: string;
  language?: string;
  subject: string;
  timezone: string;
  operator?: string;
  grade?: string;
}

export interface TimeZoneProps {
  content: {
    label: string;
    value: string;
  }[];
}

export type GetLessonAvailableListRes = {
  active: boolean;
  date: string;
  day: string;
  month: string;
  timeList: {
    startTime: string;
    endTime: string;
  }[];
  week: string;
  canSelect?: boolean;
}[];

export type GetLessonAvailableListDateRes = {
  localDate: string;
}[];

// 约课
export interface SubmitReserveReq {
  age?: string;
  cookieId?: string;
  country?: string;
  countryCode?: string;
  courseDate: string;
  courseScheduleId?: string;
  courseTime: string;
  email?: string;
  firstName: string;
  englishName: string;
  grade?: string;
  language?: string;
  lastName?: string;
  lead?: string;
  operation?: string;
  phone?: string;
  reseller?: string;
  school?: string;
  subject: string;
  timeZoneText?: string;
  wechatId?: string;
  verificationCode?: string;
  verificationMobileCode?: string;
  studentCode?: string;
  source?: string;
  ChineseLevel?: string;
  city?: string;
  timeZoneStandard?: string;
  captchaVerification?: string;
  // 当前学生线索学号
  code?: string;
  // 是否需要验证码
  needVerifyCode?: boolean;
  // 是否虚拟约课
  virtualReserve?: boolean;
  trackId?: string;
  mobileVerified?: boolean | '';
}

export interface SubmitReserveRes {
  success: string;
  content: {
    until: number;
    errorCode: number;
  };
  student: {
    code: string;
  };
  timeZoneText: string;
  courseDate: string;
  courseTime: string;
  // 本来的课程名
  scheduleName: string;
  scheduleNameEnglish: string;
  // 学生看的课程名
  scheduleNameStudent: string;
  scheduleNameStudentEnglish: string;
}

interface ReqCheckRes {
  repCode?: string;
  repData?: {
    captchaType?: string;
    token?: string;
    result?: boolean;
    opAdmin?: boolean;
  };
  success?: boolean;
  error?: boolean;
}

interface ReqCheckReq {
  captchaType?: string;
  pointJson?: string; // aes加密坐标信息
  token?: string; // get请求返回的token
}

interface GetPictureReq {
  captchaType?: string; // 验证码类型 clickWord
  clientUid?: string; // 客户端UI组件id,组件初始化时设置一次，UUID（非必传参数）
  ts?: number;
}
interface GetPictureRes {
  repCode?: string;
  repData?: {
    originalImageBase64?: string;
    point?: {
      // 默认不返回的，校验的就是该坐标信息，允许误差范围
      x?: number;
      y?: number;
    };
    jigsawImageBase64?: string;
    token?: string; // 一次校验唯一标识
    result?: string;
    opAdmin?: string;
    secretKey?: string;
  };
  success?: boolean;
  error?: boolean;
  repMsg?: string;
}

export interface GetBookingClassTimeListReq {
  date: string;
  timezone: string;
  subject: string;
  grade?: string;
  chineseLevel?: string;
  country?: string;
  age?: string;
}

interface GetIsPayingUserReq {
  email?: string;
  mobile?: string;
  studentCode?: string;
  subject?: string;
}

export interface IOwnerInfoReS {
  avatar: string;
  email: string;
  name: string;
  englishName: string;
  ownerQwShortCode: string;
  qwAvatar: string;
  qwName: string;
  quickJumpOwnerUrl?: string;
}

interface ICreateTokenSignReq {
  // 验证码
  verificationCode?: string;
  // Chinese/Math
  subject?: string;
  // 区号
  countryCode?: string;
  mobile?: string;
  // 国家代码
  country?: string;
  // 学生id
  studentId?: string;
}

interface ICreateTokenSignRes {
  token?: string;
  sign?: string;
}

export interface GetUserYearOrGradeReq {
  leadType: string;
  age?: string;
  grade?: string;
}

interface FamilyIdRes {
  content: string;
}

export const submitReserve = (params: SubmitReserveReq, headers = {}) => {
  return request.post<SubmitReserveRes, SubmitReserveRes>('/public/reserve/v2/reserve/mobile', params, {
    returnErrorMsg: true,
    skipErrorHandler: true,
    headers,
  });
};

// 获取token进入学员中心
export const createTokenSign = (params: ICreateTokenSignReq) => {
  return request.post<ICreateTokenSignRes, ICreateTokenSignRes>('/public/create/token_sign', params);
};

export const getLessonAvailableList = (params: GetLessonAvailableListReq) => {
  return request.post<GetLessonAvailableListRes, GetLessonAvailableListRes>(
    '/public/reserve/v2/available_time',
    params,
  );
};

export const getLessonAvailableDateList = (params: GetLessonAvailableDateListReq) => {
  return request.post<GetLessonAvailableListDateRes, GetLessonAvailableListDateRes>(
    '/public/reserve/available_date_v2',
    params,
  );
};

export const getTimeZoneList = () => {
  return request.get<TimeZoneProps, TimeZoneProps>(`/public/ref/timezones/ddl`);
};

// ①通过id获取页面配置数据 接口
export const getConfigurable = (params: ConfigurableReq) => {
  return request.get<ConfigurationProps, ConfigurationProps>(`/public/rs/cms/quiz/${params.id}`);
};

// ②获取所有id 接口
export const getAllID = (params: AllIDReq) => {
  return request.post<AllIDRes, AllIDRes>(`/public/rs/cms/quiz/search_list`, { ...params });
};

export const getPicture = (data: GetPictureReq) => {
  return request.post<GetPictureRes, GetPictureRes>(`/captcha/get`, data).then((res) => res);
};

export const reqCheck = (data: ReqCheckReq) => {
  return request.post<ReqCheckRes, ReqCheckRes>(`/captcha/check`, data).then((res) => res);
};

// 通过日期获取可约课时间段
export const getBookingClassTime = (params: GetBookingClassTimeListReq) => {
  return request.post<any, any>('/public/reserve/available_time_v2', params);
};

// 判断是否是付费用户 true: 付费  false: 未付费
export const getIsPayingUser = (params: GetIsPayingUserReq) => {
  return request.post<boolean, boolean>('/public/student/paid ', params);
};

// 企微二维码等信息
export const getOwnerInfo = (params: { studentCode: string; subject: string; scanTypeEnums?: string | number }) => {
  return request.post<IOwnerInfoReS, IOwnerInfoReS>('/public/owner/info', params);
};

// 年龄，年级映射
export const getUserYearOrGrade = (params: GetUserYearOrGradeReq) => {
  return request.post<any, any>('/public/grade-year', params);
};

// 年龄，年级映射
export const getUserGradeList = (params: GetUserYearOrGradeReq) => {
  return request.post<any, any>('/public/search/grade-year', params);
};

// 通过studentCode获取familyId
export const getFamilyId = (studentCode: string) => {
  return request.get<FamilyIdRes, FamilyIdRes>(`/public/reserve/getUserFamilyId?studentCode=${studentCode}`);
};
